// extracted by mini-css-extract-plugin
export var logo = "_ku-2";
export var logoWrapper = "_ku-1";
export var strip = "_ku-0";